import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import letterA from './img/letters/A.svg';
import letterP from './img/letters/P.svg';
import letterU from './img/letters/U.svg';
import letterS from './img/letters/S.svg';
import letterG from './img/letters/G.svg';
import letterE from './img/letters/E.svg';
import letterN from './img/letters/N.svg';
import letterC from './img/letters/C.svg';
import letterY from './img/letters/Y.svg';
import { inject, observer } from 'mobx-react/index';
import { isProduction } from '../../utils';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 2;
  will-change: opacity;
`;

const Image = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  visibility: hidden;

  ${props =>
    props.active &&
    css`
      visibility: visible;
    `};
`;

const Letter = ({ image, active }) => <Image src={image} active={active} />;

Letter.propTypes = {
  image: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

class Preloader extends React.Component {
  static propTypes = {
    preloaderStore: PropTypes.object.isRequired,
    scrollControllerStore: PropTypes.object.isRequired,
  };

  intervalDuration = 180;
  letters = [letterA, letterP, letterU, letterS, letterA, letterG, letterE, letterN, letterC, letterY];

  state = {
    activeIndex: -1,
  };

  componentDidMount() {
    this.props.scrollControllerStore.lock();

    if (!isProduction()) {
      this.remove();
      this.props.preloaderStore.setLoaded();
      return;
    }

    window.addEventListener('load', () => {
      setTimeout(() => {
        this.intervalId = setInterval(() => this.switch(), this.intervalDuration);
      }, 500);
    });
  }

  switch() {
    if (this.state.activeIndex === this.letters.length - 1) {
      this.remove();
      return;
    }

    this.setState(state => ({ activeIndex: state.activeIndex + 1 }));
  }

  remove() {
    clearInterval(this.intervalId);
    this.wrapperNode.parentNode.removeChild(this.wrapperNode);
    this.props.scrollControllerStore.unlock();
    this.props.preloaderStore.setLoaded();
  }

  render() {
    return (
      <Wrapper innerRef={node => (this.wrapperNode = node)}>
        {this.letters.map((letter, index) => (
          <Letter key={index} image={letter} active={this.state.activeIndex === index} />
        ))}
      </Wrapper>
    );
  }
}

export default inject(stores => ({
  preloaderStore: stores.store.preloaderStore,
  scrollControllerStore: stores.store.scrollControllerStore,
}))(observer(Preloader));



// WEBPACK FOOTER //
// ./src/components/Preloader/index.js